import { TranslationObject } from '@ngx-translate/core';

const es: TranslationObject = {
  es: 'Español',
  en: 'Inglés',
  app: {
    title: 'Revisión de Seguridad Previa al Inicio',
    forms: {
      ok: 'Ok',
      cancel: 'Cancelar',
      create: 'Crear',
      continue: 'Continuar',
      selectAll: 'Seleccionar Todo',
      save: 'Guardar',
      labels: {
        businessUnit: 'Unidad de Negocio',
        organization: 'Organización',
        user: 'Usuario',
        name: 'Nombre',
        description: 'Descripción',
        displayRichEditor: 'Mostrar editor de texto enriquecido',
        statusOptions: {
          draft: 'Draft',
          initiated: 'Initiated',
          inProgress: 'In Progress',
          completed: 'Completed',
          pendingApproval: 'Pending Approval',
          approved: 'Approved',
          closed: 'Closed',
        },
        placeHolderDescription: 'Ingresa una descripción',
        placeHolderReviewType: 'Selecciona un tipo de revisión',
        mandatory: 'Obligatorio',
        isActive: 'Activo',
      },
      categories: {
        placeholders: {
          categoryName: 'Nombre de categoría',
        },
      },
      unsavedChangesWarning:
        'Se han detectado cambios no guardados. Si abandonas esta página, las modificaciones que realizaste se perderán.<br>¿Deseas continuar?',
      validation: {
        required: '{{controlName}} es obligatorio',
        invalidEmail: 'Por favor, ingrese una dirección de correo electrónico válida',
      },
    },
    warnings: {
      removeOwnAccess: 'Has eliminado tu acceso. Por favor, actualiza la página web para evitar malfunciones.',
      removeOwnAdminRights:
        'Has eliminado tus derechos de administrador. Por favor, actualiza la página web para evitar malfunciones.',
    },
  },
  header: {
    support: 'Soporte',
    userGuide: 'Guía del Usuario',
  },
  navigation: {
    pssrs: '{{pssrTitle}}s',
    projects: 'Proyectos',
    actionsItems: 'Items de acción',
    administration: 'Administración',
    hierarchyManagement: 'Gestión de Jerarquía',
    businessUnits: 'Unidades de Negocio',
    organizations: 'Organizaciones',
    facilityHierarchy: 'Jerarquía de Instalación',
    accessManagement: 'Gestión de Acceso',
    organizationUsers: 'Usuarios',
    buAdmins: 'Administradores de usuarios',
    userGroups: 'Grupos de usuarios de acciones',
    systemAdmins: 'Administradores del sistema',
    pssrConfiguration: 'Configuración para PSSRs',
    templates: 'Listas de verificación PSSR',
    categories: 'Categorías de unidad de negocio',
  },
  functionalReviewList: {
    title: 'Revisión Funcional',
    noFunctionalReview: 'Sin revisión funcional',
    id: 'ID',
    code: 'Código',
    question: 'Pregunta',
    answer: 'Respuesta',
    comment: 'Comentario',
    updatedBy: 'Actualizado Por',
    updatedDate: 'Fecha de Actualización',
    createNewFunctionalReview: 'crear nueva revisión funcional',
    reviewType: 'Tipo de Revisión',
    addQuestion: 'Agregar Pregunta',
    description: 'Descripción',
    subSection: 'Sub Sección',
    clearAnswer: 'Limpiar Respuesta',
    deleteQuestion: 'Eliminar Pregunta',
    deleteQuestionTitle: 'Eliminar Pregunta',
    confirmDeleteQuestion:
      '<span>¿Está seguro de que desea eliminar esta pregunta?</span><br><br><span><b>Pregunta:</b> {{ description }}</span>',
    generateReport: 'Generar Reporte',
    completeReview: 'Completar Revisión',
    generateSuccessMessage: 'Reporte generado con éxito',
    reviewSuccessMessage: 'Revisión Funcional completada con éxito',
  },
  admin: {
    sysAdminList: {
      title: 'Administradores del Sistema',
      addSysAdmin: 'agregar administrador del sistema',
      fullName: 'nombre completo',
      disabled: 'Deshabilitado',
      email: 'email',
      dialogs: {
        removeAccessHeader: 'Confirmación',
        removeAccessMessage:
          '¿Está seguro de que desea eliminar el acceso de administrador del sistema para: [{{firstName}} {{lastName}}]?',
      },
    },
    businessUnitLists: {
      title: 'Unidades de Negocio',
      addBusinessUnit: 'agregar unidad de negocio',
      tableTitle: 'Unidad de Negocio',
    },
    businessUnitCreate: {
      title: 'Crear Unidad de Negocio',
    },
    businessUnitEdit: {
      title: 'Editar Unidad de Negocio',
    },
    businessUnitForm: {
      sections: {
        supportInformation: {
          titleSupport: 'Información de Soporte',
          name: 'Nombre',
          businessUnitSupportInfo: 'Información de Soporte de la Unidad de Negocio',
          businessUnitSupportInfoDescription: 'Esta información se mostrará en la página de soporte',
          displayRichEditor: 'mostrar editor enriquecido',
        },
        approvalForAccess: {
          titleApproval: 'Aprobación para Acceso',
          userNeedsBuAdmin: 'El usuario necesita que un administrador de la unidad de negocio le otorgue acceso',
          userGetsInstantAccess: 'El usuario obtendrá acceso instantáneo',
        },
        labels: {
          titleLabels: 'Etiquetas',
          hierarchyLabel1: 'Etiqueta de Jerarquía 1',
          hierarchyLabel2: 'Etiqueta de Jerarquía 2',
          hierarchyLabel3: 'Etiqueta de Jerarquía 3',
          pssrLabel: 'Etiqueta PSSR',
          organizationLabel: 'Etiqueta de Organización',
          eventNameLabel: 'Etiqueta de Nombre de Evento',
          p3: 'P3',
          p4: 'P4',
          p5: 'P5',
          placeholderDefault: 'el valor predeterminado es \'proyecto\'',
          show: 'mostrar',
        },
        pssrConfigurations: {
          titleConfigurations: 'Configuraciones PSSR',
          stagnantPssrInterval: 'Intervalo de PSSR Estancado',
          instructions: 'Instrucciones',
          instructionsDescription: 'Instrucciones generales estancadas para PSSR',
          showProject: '¿Desea mostrar Proyecto?',
          projectDisplayType: '¿Cómo desea mostrar Proyecto?',
          dropdown: 'lista desplegable',
          input: 'entrada',
          showKms: '¿Desea mostrar KMS? Se mostrará un botón "obtener de KMS" al crear un nuevo PSSR.',
          showQaqcModule: '¿Desea mostrar el Módulo QAQC en el Proyecto? Requiere que el proyecto esté habilitado.',
          showWetSignatureApproval:
            '¿Desea permitir una firma húmeda del PSSR? Esto permite que el Representante de Operaciones apruebe el PSSR en estado de aprobación pendiente. El botón dice "aprobar con firma húmeda".',
          pssrTypesToShow: '¿Qué Tipos de PSSR desea mostrar?',
          ccc: 'CCC',
          factory: 'Fábrica',
          moc: 'MOC',
          nonMoc: 'NO-MOC',
          orr: 'ORR',
          pfsr: 'PFSR',
          test: 'Prueba',
          showNaResponse:
            '¿Desea permitir que los usuarios respondan N/A? Si selecciona no, se requerirá un comentario o elemento de acción para considerarse completado.',
          sendScheduledEmail:
            '¿Desea enviar un correo electrónico programado cada lunes a las 8:00 AM CST a usuarios con elementos de acción pendientes?',
          showConstructionComplete:
            '¿Desea mostrar el Certificado de Construcción Completa (CCC) para algunos encabezados/títulos/etiquetas?',
          showOperationReadiness:
            '¿Desea mostrar la Revisión de Preparación Operativa (ORR) para algunos encabezados/títulos/etiquetas?',
          showVerbalApproval:
            '¿Desea mostrar aprobación verbal? Esto muestra una entrada en la aplicación móvil para escribir manualmente quién está aprobando. Esto no causa ninguna acción y puede ser realizado por el líder o aprobador.',
          allowLeadToDelete:
            '¿Desea permitir que el líder elimine preguntas para un PSSR en estado borrador o iniciado?',
          allowTeamMemberActions:
            '¿Desea permitir que cualquier miembro del equipo responda preguntas, firme preguntas y cree elementos de acción hasta que se apruebe?',
          restrictMocWo:
            '¿Desea restringir el número de proyecto MOCWO? Si selecciona "sí", se requieren MOC y WO para crear un PSSR.',
          allowLeadsToShare:
            '¿Desea permitir que los Líderes compartan el dispositivo con los aprobadores? Si selecciona "sí", el líder puede compartir el dispositivo con el aprobador si el aprobador está presente para firmar.',
          requireFinalApprovalBeforeInitiation:
            '¿Desea requerir aprobación final antes de la iniciación? Si es "sí", el PSSR requerirá tener un aprobador final para iniciarlo.',
          allowFinalApproverNotifications: '¿Desea permitir que el aprobador final reciba todas las notificaciones?',
          allowFinalApproverSubmit: '¿Desea permitir que el aprobador final envíe para aprobación?',
          allowMultiplesApprovers: '¿Desea permitir múltiples aprobadores?',
          ShowSectionsCollapsed: '¿Desea colapsar las secciones de PSSR al editar?',
          requireActionItemDueDate: '¿Desea requerir una fecha de vencimiento para los elementos de acción?',
          limitAccessToAIOwner:
            '¿Desea restringir al propietario o asignado del elemento de acción de modificar la descripción, cambiar la fecha de vencimiento o eliminar el elemento de acción?',
        },
        actionItemConfigurations: {
          titleItemConfigurations: 'Configuraciones de Elementos de Acción',
          sendToMoc: '¿Desea enviar elementos de acción a MOC?',
          p3: 'P3',
          p4: 'P4',
          allowTeamLeadAttach:
            '¿Desea permitir que el líder del equipo adjunte y modifique un elemento de acción? Si selecciona "sí", los líderes solo pueden adjuntar archivos, asignado, estado y comentario después de la aprobación pendiente.',
          allowActionItemOwnerAttach:
            '¿Desea permitir que el propietario del elemento de acción adjunte en cualquier estado mientras el PSSR no esté cerrado?',
        },
      },
    },
  },
  user: {
    requestAccess: {
      title: 'No Registrado',
      forms: {
        submit: 'Solicitar Acceso',
      },
      dialogTitle: 'Solicitar Acceso',
      dialogSubtitle: 'Está por solicitar acceso a  <strong>{{Name}}</strong>, desea continuar?',
      reloadWarning:
        'Si visitas esta página pero ya tienes acceso, haz clic en el siguiente enlace para recargar; de lo contrario, contacta con el soporte.',
      reload: 'recargar',
    },
    pendingAccess: {
      title: 'Hola, su solicitud de acceso está en curso',
      reloadWarning:
        'Si visitas esta página pero ya tienes acceso, haz clic en el siguiente enlace para recargar; de lo contrario, contacta con el soporte.',
      reload: 'recargar',
    },
  },
  footer: {
    text: 'Chevron Corporation. Todos los derechos reservados.',
  },
  checklist: {
    title: 'Lista de Verificación PSSR',
    create: 'crear nuevo',
    hideCode: 'ocultar código',
    code: 'Código',
    name: 'Nombre de lista de verificación',
    edit: 'editar',
    manage: 'administrar',
    delete: 'eliminar',
    defaultWalkthroughDisclaimer: 'Descargo de responsabilidad predeterminado de la firma de recorrido',
    defaultSummaryDisclaimer: 'Descargo de responsabilidad predeterminado de la firma de resumen',
    displayRichEditor: 'mostrar editor enriquecido',
    sampleText: 'texto de muestra',
    dialogs: {
      removeAccessHeader: 'Confirmación',
      removeAccessMessage: '¿Está seguro de que desea eliminar [{{description}}]?',
    },
    titleCreate: 'Crear lista de verificacion',
    createNew: 'Crear nuevo',
    selectPlaceholder: 'Seleccione BU',
    titleEdit: 'Editar listas de verificación',
    titleDelete: 'Eliminar lista de verificación',
    deletedSuccessfully: 'Lista de verificación eliminada con éxito',
    noChecklists: 'No hay listas de verificación disponibles.',
    importChecklist: 'Importar lista de verificación',
    importChecklistTitle: 'Importar lista de verificación a',
    selectChecklistType: 'Seleccionar tipo de lista de verificación',
    confirm: 'Confirmar',
    importSuccessMessage: 'Lista de verificación importada correctamente',
  },
  common: {
    yes: 'Si',
    no: 'No',
    na: 'N/A',
    save: 'Guardar',
    saving: 'Guardando...',
    businessUnit: 'Unidad de negocio',
    forbidActionErrorMessage: 'El usuario no está autorizado para realizar esta acción.',
    name: 'Nombre',
    code: 'Código',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    back: 'Volver',
    genericErrorMessage: 'Ha ocurrido un error inesperado. Por favor, inténtelo de nuevo más tarde.',
    errorOccurred: 'Se produjo un error. Por favor, inténtelo de nuevo.',
    savedSuccessfully: 'Guardado con éxito',
    delete: 'Eliminar',
    deletedSuccessfully: 'Eliminado con éxito',
    edit: 'Editar',
    leaveWithOutSaving: 'Salir sin guardar',
    language: 'Idioma',
    month: 'Mes',
    months: 'Meses',
    loading: 'Cargando...',
    all: 'Todos',
    recordAlreadyExists: 'El registro ya existe',
    recordCreatedSuccessfully: 'Registro creado exitosamente',
    createdSuccessfully: 'Creado exitosamente',
  },
  checklistManage: {
    title: 'Manejar Contenido de [{{ description }}]',
    sectionsTitle: 'Secciones',
    addSectionAction: 'agregar sección',
    mandatoryLabel: 'Obligatorio',
    createNewSubsectionAction: 'Crear Nueva Subsección',
    emptySubSectionsMessage:
      '<p>No hay contenido disponible para esta sección.</p><p>Por favor, agregue una subsección para comenzar.</p>',
    itemCodeTableHeader: 'Código',
    itemDescriptionTableHeader: 'Descripción',
    createNewItemAction: 'Agregar pregunta',
    createSectionHeader: 'Crear Sección',
    editSectionHeader: 'Editar Sección',
    confirmDeleteSection: '¿Está seguro de que desea eliminar la sección <strong>{{description}}</strong>?',
    createSubSectionHeader: 'Crear subsección',
    editSubSectionHeader: 'Editar subsección',
    createChecklistItemTitle: 'Crear elemento de lista de verificación',
    editChecklistItemTitle: 'Editar elemento de lista de verificación',
    ShouldAddCommentToQuestion: 'El usuario debe añadir un comentario a cualquier pregunta respondida con N/D',
    autoGenerateCodeLabel: 'Generar código automáticamente',
    autoGenerateCodeplaceholder: 'El código se generará automáticamente',
    autoGenerateCodeInfo: 'Se ha activado la autogeneración, el campo se completará automáticamente.',
    deleteChecklistItemTitle: 'Eliminar elemento de lista de verificación',
    confirmDeleteChecklistItem:
      '<span>¿Está seguro de que desea eliminar este elemento de lista de verificación?</span><br><br><span><b>Código:</b> {{ name }}<br><b>Descripción:</b> {{ description }}</span>',
    confirmDeleteSubSection: '¿Está seguro de que desea eliminar la subsección <strong>{{description}}</strong>?',
    deleteSectionHeader: 'Eliminar Sección',
    deleteSubSectionHeader: 'Eliminar Subsección',
    editQuestionTitle: 'Editar pregunta',
    sectionTypeLabel: 'Tipo de Sección',
    sectionTypePlaceholder: 'Seleccione un tipo de sección',
    subSectionNameLabel: 'Nombre de la Subsección',
    itemTypeLabel: 'Tipo',
    itemTypePlaceholder: 'seleccione uno',
    codePlaceholder: 'Ingrese el código',
    duplicateCodeError: 'Este código ya se utiliza en otra sección.',
    displayRichEditorLabel: 'Mostrar editor enriquecido',
    requireCommentForNA: '¿Desea requerir un comentario para una pregunta N/D?',
  },
  paginator: {
    previous: 'Anterior',
    next: 'Siguiente',
    currentPageReport: '{{currentInitialRow}} - {{currentLastRow}} de {{totalRecords}}',
  },
  usersList: {
    title: 'Usuarios',
    forms: {
      displayInactiveUsers: 'mostrar usuarios inactivos',
      search: 'Búsqueda',
    },
    actions: {
      addNewUser: 'Agregar nuevo usuario',
      grantAccess: 'conceder acceso',
      reimportAllSharedUsers: 'Reimportar todos los usuarios compartidos',
    },
    table: {
      fullName: 'nombre completo',
      email: 'email',
      admin: 'admin',
      type: 'tipo',
    },
    noUsers: 'No hay usuarios disponibles',

    dialogs: {
      removeAccessHeader: 'Confirmación',
      removeAccessMessage: '¿Estás seguro de que deseas eliminar el acceso para: [{{fullName}}]?',
      addUserHeader: 'Agregar nuevo usuario',
      editUserHeader: 'Editar usuario',
      reimportSharedUsersHeader: 'Reimportar todos los usuarios compartidos',
      reimportSharedUsersMessage:
        'Está a punto de actualizar la configuración de todos los usuarios compartidos.<br> Esta operación podría tomar varios minutos en completarse.',
    },
    messages: {
      importSharedUsersFailed: 'Falló la importación',
      importSharedUsersIncompleted: 'Importación incompleta',
      importSharedUsersCompleted: 'Importación completada en: {{ minutes }} mins',
      pleaseWaitUntilProcessEnds:
        'Por favor, espere hasta que se complete el proceso de importación. No cierre ni navegue fuera de esta página.',
      importInProgress:
        'La importación está en progreso. Por favor espere hasta que se complete antes de cerrar la página.',
      calculatingProgress: 'Calculando progreso...',
    },
    labels: {
      imported: 'Importados',
      notFound: 'No Encontrado',
      errors: 'Errores',
      total: 'Total',
    },
  },
  actionItems: {
    id: 'ID',
    title: 'Elementos de Acción',
    addActionItem: 'agregar elemento de acción',
    noActionItems: 'No hay elementos de acción disponibles',
    canOnlyPerformAttachments:
      'Solo puede administrar archivos adjuntos. No se pueden editar otras propiedades del elemento de acción.',
    actionTitle: 'Título',
    assignee: 'Responsable',
    date: 'Fecha',
    dueDate: 'Fecha límite',
    category: 'Categoría',
    primaryCategory: 'Categoría principal',
    secondaryCategory: 'Categoría secundaria',
    subcategory: 'Subcategoría',
    comment: 'Comentario',
    editComment: 'Editar Comentario',
    commentRequiredWhenClosed: 'El comentario es obligatorio cuando el estado está configurado como Cerrado',
    priority: 'Prioridad',
    assignTo: 'Asignar a',
    pssrCccMembers: 'Miembros {{pssrTitle}}',
    chevronDirectory: 'Directorio Chevron',
    userGroup: 'Grupo de usuarios',
    other: 'Otro',
    status: 'Estado',
    statusNames: {
      Open: 'Abierto',
      Closed: 'Cerrado',
      Cancel: 'Cancelado',
      Rejected: 'Rechazado',
    },
    createdBy: 'Creado por',
    updatedDate: 'Fecha de actualización',
    updatedBy: 'Actualizado por',
    selectOne: 'Seleccione uno...',
    typeNameOrEmail: 'Escriba nombre o correo...',
    inactive: 'Inactivo',
    reopen: 'Reabrir',
    reject: 'Rechazar',
    rejectReason: 'Razón de Rechazo',
    rejectReasonPlaceholder: 'Ingrese la razón del rechazo',
    timeCaptured: 'Hora Capturada',
    attachments: 'Archivos adjuntos',
    pssrFiles: 'Archivos PSSR',
    links: 'Enlaces',
    fileUpload: 'Carga de archivos',
    attachFiles: 'Adjuntar (docs, imágenes, etc.)',
    fileTooLarge: 'El archivo \'{{name}}\' supera el tamaño máximo permitido de {{max}}.',
    invalidFileFormat: 'El archivo \'{{name}}\' tiene un formato no compatible.',
    duplicateFile: 'El archivo \'{{name}}\' ya ha sido agregado.',
    linkPlaceholder: 'www.ejemplo.com',
    dialogs: {
      configureComment: 'Comentario',
      configureActionItem: 'Configurar items de acción',
      deleteActionItemHeader: 'Borrar item de acción',
      deleteActionItemMessage: 'Confirma que desea realizar esta acción?',
      rejectActionItemHeader: 'Rechazar Item de Acción',
      confirmPriorityChangeHeader: 'Confirmar Cambio de Prioridad',
      confirmPriorityChangeMessage: '¿Está seguro de que desea cambiar la prioridad de este elemento de acción?',
      deleteAttachmentHeader: 'Eliminar Archivo Adjunto',
      deleteAttachmentMessage: '¿Está seguro de que desea eliminar este archivo adjunto?',
    },
    messages: {
      deleteSuccess: 'Item de acción eliminado exitosamente',
      reopenSuccess: 'Item de acción reabierto exitosamente',
      rejectSuccess: 'Item de acción rechazado exitosamente',
      rejectReasonRequired: 'La razón de rechazo es requerida',
      confirmReject: '¿Está seguro de que desea rechazar este item de acción? Se {{action}}.',
      confirmRejectP4: '¿Está seguro de que desea rechazar este item de acción?',
      returnToTeamLead: 'regresará al Líder del Equipo',
      confirmReopen: '¿Está seguro de que desea reabrir este item de acción?',
    },
  },
  actionItemsList: {
    title: 'Elementos de Acción',
    sections: {
      location: 'Ubicación',
      pssr: 'PSSR',
      actionItem: 'Elemento de Acción',
    },
    fields: {
      area: 'Área',
      facilityOperationTeam: 'Equipo de Operaciones de Instalación',
      facility: 'Instalación',
      titleStatus: 'Estado del Título',
      type: 'Tipo',
      title: 'Título',
      project: 'Proyecto',
      template: 'Plantilla',
      leadFinalApprover: 'Líder/Aprobador Final',
      showOnlyDeletedPssr: 'Mostrar Solo PSSR Eliminados',
      status: 'Estado',
      priority: 'Prioridad',
      assignedTo: 'Asignado a',
      autoLoadImages: 'Carga Automática de Imágenes',
    },
    placeholders: {
      selectOne: 'seleccione uno',
      sampleText: 'texto de ejemplo',
      no: 'Seleccione No',
    },
    priorityDescriptions: {
      p3: 'El elemento debe completarse antes del inicio',
      p4: 'El elemento se completará después del inicio',
      p5: 'El elemento debe completarse antes del inicio',
    },
    priorityLegend: {
      title: 'Prioridades de Elementos de Acción',
    },
    actions: {
      clearFilter: 'limpiar filtro',
      exportExcel: 'exportar excel',
      noDataToExport: 'Sin elementos de acción para exportar',
    },
    imageAltText: 'Imagen del Elemento de Acción',
    pssrTeamLead: 'Líder del Equipo PSSR',
    finalApprover: 'Aprobador Final',
    subsection: 'Subsección',
    code: 'Código',
    question: 'Pregunta',
    answer: 'Respuesta',
    noData: 'No hay elementos de acción disponibles',
    noDataFound: 'No se encontraron elementos de acción para los filtros seleccionados',
  },
  responseSignature: {
    signedBy: 'Firmado Por',
    signedOn: 'Firmado El',
    name: 'Nombre',
    dateCaptured: 'Fecha Capturada',
    sign: 'Firmar',
    finalApproverLabel: 'Aprobador Final',
    dialogs: {
      deleteHeader: 'Eliminar firma',
      deleteMessage: 'Está a punto de eliminar la firma, por favor seleccione confirmar para continuar',
      cancel: 'cancelar',
      delete: 'eliminar',
    },
  },
  comments: {
    title: 'Comentarios',
    comment: 'Comentario',
    addComment: 'Agregar Comentario',
    dialogs: {
      configureComment: 'Comentario',
      deleteCommentHeader: 'Borrar Comentario',
      deleteCommentMessage: 'Confirma que desea realizar esta acción?',
    },
  },
  userType: {
    Chevron: 'Chevron',
    External: '3ra Parte (externo)',
    Shared: 'Compartido',
  },
  areas: {
    title: 'Área',
    showDeletedItems: 'Mostrar elementos eliminados',
    areaListTitle: 'Lista de áreas',
    createFacilityOperationTeam: 'Crear nuevo equipo de operación de instalaciones',
    createFacility: 'Crear nueva instalación',
    restore: 'Restaurar',
    emptySubAreaMessage:
      '<p>No hay contenido disponible para esta área.</p><p>Por favor, agregue un nuevo equipo de operación de instalaciones para comenzar.</p>',
    emptyHierarchyChildrenMessage:
      '<p>No hay <strong>{{childLabel}}</strong> disponibles para este <strong>{{parentLabel}}</strong>.</p><p>Por favor, agregue un nuevo <strong>{{childLabel}}</strong> para comenzar.</p>',
    emptyAreaMessage:
      '<p>No hay contenido disponible para esta unidad de negocio.</p><p>Por favor, agregue una nueva área para comenzar.</p>',
    subareaTitle: 'Equipo de Operación de Instalaciones',
    facilityTitle: 'Instalación',
    removeConfirmationHeader: 'Confirmación',
    confirmDeleteArea: '¿Está seguro de que desea eliminar el Área <strong>{{description}}</strong>?',
    confirmDeleteSubarea:
      '¿Está seguro de que desea eliminar el Equipo de Operación de Instalaciones <strong>{{description}}</strong>?',
    confirmDeleteFacility: '¿Está seguro de que desea eliminar la Instalación <strong>{{description}}</strong>?',
    restoredSuccessfully: 'Restaurado con éxito',
  },
  organizationsList: {
    title: 'Organizaciones',
    tableHeader: 'organización',
    noOrganizations: 'No hay organizaciones disponibles',
    successCreated: 'Organización creada exitosamente',
    actions: {
      addNew: 'agregar nueva organización',
    },
    forms: {
      name: 'Nombre de la Organización',
      namePlaceholder: 'escribir nombre de organizacion',
    },
    dialogs: {
      addNew: 'Agregar Nueva Organización',
      edit: 'Editar Organización',
      deleteHeader: 'Eliminar Organización',
      deleteMessage: '¿Está seguro de que desea eliminar la organización: [{{name}}]?',
    },
  },
  userGroupsList: {
    title: 'Grupos de Usuarios de Elementos de Acción',
    groupsSection: 'Grupos',
    noUsers: 'No hay usuarios en este grupo',
    noGroups: 'No hay grupos disponibles',
    selectGroup: 'Seleccione un grupo para ver usuarios',
    actions: {
      create: 'crear',
      addNewUser: 'agregar nuevo usuario',
      selectUser: 'Seleccionar Usuario',
      changeUser: 'Cambiar Usuario',
      add: 'Agregar',
    },
    table: {
      userName: 'nombre de usuario',
      email: 'email',
    },
    forms: {
      namePlaceholder: 'Ingrese el nombre del grupo',
      selectUserPrompt: 'Por favor seleccione un usuario para agregar a este grupo',
      selectedUser: 'Usuario Seleccionado',
    },
    dialogs: {
      addGroup: 'Agregar Nuevo Grupo',
      editGroup: 'Editar Grupo',
      deleteGroupHeader: 'Eliminar Grupo',
      deleteGroupMessage: '¿Está seguro de que desea eliminar el grupo: [{{name}}]?',
      removeUserHeader: 'Eliminar Usuario',
      removeUserMessage: '¿Está seguro de que desea eliminar a {{name}} de este grupo?',
      addUser: 'Agregar Usuario al Grupo',
      selectUser: 'Seleccionar Usuario',
    },
  },
  pssrImport: {
    title: 'Importar MOC',
    sections: {
      import: 'Importar',
    },
    forms: {
      labels: {
        application: 'Aplicación',
        pssrId: 'ID',
        mocId: 'ID de MOC',
        mocName: 'Nombre de MOC',
      },
      placeholders: {
        application: 'seleccionar una opción',
        pssrId: 'Ingrese el ID de MOC',
        mocName: 'Autocompletado desde iMOC',
      },
      validation: {
        mocIdRequired: 'El ID de MOC es obligatorio',
        applicationRequired: 'La aplicación es obligatoria',
      },
    },
    actions: {
      add: 'Agregar',
      addMoc: 'Agregar MOC',
      importAll: 'Importar Todo',
      createPssr: 'crear PSSR',
      searchMoc: 'buscar MOC',
      importMocCreatePssr: 'Importar MOC y crear PSSR',
    },
    table: {
      id: 'ID',
      pssrId: 'ID PSSR',
      name: 'Nombre',
      status: 'Estado',
    },
    summary: {
      records: 'Registros',
      imported: 'Importados',
      errors: 'Errores',
    },
    status: {
      pending: 'Pendiente',
      inProgress: 'En Progreso',
      imported: 'Importado',
      warning: 'Advertencia',
      error: 'Error',
    },
    messages: {
      alreadyInList: 'El ID de PSSR ya está en la lista de importación.',
      pssrNotFound: 'PSSR no encontrado.',
    },
  },
  pssrCreate: {
    title: 'Crear PSSR',
    sections: {
      generalInformation: 'Información General',
      location: 'Ubicación',
      details: 'Detalles',
      instructions: 'Instrucciones',
    },
    forms: {
      labels: {
        title: 'Título',
        moc: 'MOC',
        wo: 'WO',
        description: 'Descripción',
        area: 'Área',
        facilityOperationTeam: 'Equipo de Operación de Instalación',
        facility: 'Instalación',
        project: 'Proyecto',
        template: 'Plantilla',
        type: 'Tipo',
        organization: 'Organización',
        subArea: 'Subárea',
        includeProjectTeam: 'Incluir miembros del equipo del proyecto',
      },
      placeholders: {
        title: 'texto de muestra',
        moc: 'texto de muestra',
        wo: 'texto de muestra',
        description: 'Ingresa descripción',
        area: 'selecciona uno',
        facilityOperationTeam: 'selecciona uno',
        facility: 'selecciona uno',
        project: 'selecciona uno',
        template: 'selecciona uno',
        type: 'selecciona uno',
        subArea: 'selecciona uno',
      },
      validation: {
        titleRequired: 'El título es requerido',
        mocRequired: 'MOC es requerido',
        woRequired: 'WO es requerido',
        businessUnitRequired: 'La unidad de negocio es requerida',
        organizationRequired: 'La organización es requerida',
        areaRequired: 'El área es requerida',
        facilityOperationTeamRequired: 'El equipo de operación de instalación es requerido',
        facilityRequired: 'La instalación es requerida',
        projectRequired: 'El proyecto es requerido',
        templateRequired: 'La plantilla es requerida',
        typeRequired: 'El tipo es requerido',
        requiredFieldsMessage: 'Nota: Complete los campos marcados como obligatorios. Haga clic en Guardar.',
      },
      templateChangeConfirmTitle: 'Cambiar plantilla',
      templateChangeConfirmMessage:
        'Cambiar la plantilla actualizará las secciones del PSSR. ¿Está seguro de que desea cambiar la plantilla?',
    },
    actions: {
      create: 'crear',
      pullFromKMS: 'Obtener desde KMS',
    },
    successMessage: 'PSSR creado exitosamente',
  },
  pssrKms: {
    title: 'PSSR desde KMS',
    sections: {
      generalInformation: 'Información General',
      pssrInformation: 'Información PSSR',
      location: 'Ubicación',
      details: 'Detalles',
    },
    kmsInstruction:
      'Busque un número MOC específico o filtre la lista por estado y tamaño de página para importar datos desde KMS.',
    searchMOCNumber: 'Buscar Número MOC',
    mocPattern: 'ej., MOC-2024-123',
    invalidMOCFormat: 'Formato MOC inválido. Ejemplo: MOC-2024-123',
    search: 'Buscar',
    filterByStatus: 'Filtrar Lista KMS por Estado',
    filterPageSize: 'Filtrar Número de Elementos KMS devueltos',
    selectFromList: 'Seleccionar de Lista MOC KMS',
    selectKMSItems: 'Seleccionar elementos KMS',
    createNew: 'Crear Nuevo',
    enterName: 'Ingresar nombre',
    add: 'Agregar',
    enterProjectNumber: 'Ingresar número de proyecto',
    selectQAQCEvent: 'Seleccionar evento QAQC',
    selectFromQAQC: 'Seleccionar desde QAQC',
    milestones: 'Hitos',
    workOrders: 'Órdenes de Trabajo',
    selectMilestone: 'Seleccionar hito',
    selectWorkOrder: 'Seleccionar orden de trabajo',
    milestoneWorkOrders: 'Órdenes de Trabajo de Hitos',
    note: 'Nota',
    fillRequiredFields: 'Por favor complete los campos que están marcados como requeridos',
    generatePSSRs: 'Generar PSSRs',
    successMessage: 'PSSR desde KMS creado exitosamente',
    multipleSuccessMessage: 'Múltiples PSSRs desde KMS creados exitosamente',
    loadingKMSItemsError: 'Error al cargar elementos KMS. Por favor intente nuevamente.',
    selectKMSItemsWarning: 'Por favor seleccione al menos un elemento KMS',
    kmsStatus: {
      draft: 'Borrador',
      processActivated: 'Proceso Activado',
      reviewInProgress: 'Revisión en Progreso',
      implementationInProgressEdit: 'Implementación en Progreso Editar',
      changeRequestApproved: 'Solicitud de Cambio Aprobada',
      changeRequestDenied: 'Solicitud de Cambio Denegada',
      implementationInProgress: 'Implementación en Progreso',
      readyToStartUp: 'Listo para Iniciar',
      completed: 'Completado',
      canceled: 'Cancelado',
      onHold: 'En Espera',
    },
    businessUnit: 'Unidad de Negocio',
    selectPlaceholder: 'Seleccione uno',
  },
  pssrSubSections: {
    actions: {
      addQuestion: 'Agregar pregunta',
    },
  },
  pssrDetails: {
    title: 'Detalles del PSSR',
    pssrId: 'ID del PSSR',
    sections: {
      generalInformation: 'Información General',
      location: 'Ubicación',
      details: 'Detalles',
      sectionsTitle: 'Secciones',
      actionItems: 'Elementos de Acción',
      comments: 'Comentarios',
      enableCustomOrderForSections: 'Habilitar orden personalizado para secciones',
      sectionsLegendTitle: 'Leyenda de secciones',
      hideCompletedQuestions: 'Ocultar preguntas completadas',
      saveSectionOrder: 'Guardar orden de secciones',
      confirmRemoveSectionTitle: 'Eliminar seccion',
      confirmRemoveSectionDescription: 'Confirma que desea eliminar {{description}}?',
      sectionNameLabel: 'Nombre de la Sección',
      sectionNamePlaceholder: 'Ingrese el nombre de la sección',
      editSectionName: 'Editar nombre de sección',
      addMultipleSectionName: 'Agregar sección múltiple',
      validation: {
        sectionNameRequired: 'El nombre de la sección es requerido',
        sectionNameDuplicated: 'Ya existe una sección con este nombre',
      },
      toast: {
        unableToCompleteOperation: 'No se pudo completar la operación',
        saveCompletedTitle: 'Guardado completado',
        sectionsSortedSuccessfully: 'Las secciones se ordenaron correctamente',
        loadSectionsError: 'Error al cargar las secciones. Por favor, inténtalo de nuevo.',
        userAlreadyAdded: 'Usuario ya agregado a esta sección',
        userAddedSuccessfully: 'Usuario agregado exitosamente',
        sectionAddedSuccessfully: 'Sección agregada exitosamente',
        sectionUpdatedSuccessfully: 'Sección actualizada exitosamente',
      },
      selectLead: 'selecciona líder',
      section1Title: 'Sección 1',
      legend: {
        defaultQuestionLabel: 'pregunta por defecto',
        defaultQuestionDescription: 'pregunta que puede responderse con sí, no o n/a',
        optionalLabel: 'opcional',
        optionalDescription: 'puede agregarse manualmente al PSSR',
        multipleLabel: 'múltiple',
        multipleDescription: 'opcional pero puede agregarse varias veces al PSSR',
        mandatoryLabel: 'obligatorio',
      },
      instructions: 'Instrucciones',
      history: 'Historial de cambios de PSSR',
      attachments: 'Archivos Adjuntos PSSR',
    },
    subsections: {
      actionItemNeeded: 'Nota: Se necesita un elemento de acción para completar las preguntas.',
    },
    questions: {
      code: 'Código',
      question: 'Pregunta',
      answer: 'Respuesta',
      updatedBy: 'Actualizado Por',
      updatedDate: 'Fecha de Actualización',
      clearAnswer: 'limpiar respuesta',
      deleteQuestion: 'eliminar pregunta',
      answerUpdated: 'Respuesta actualizada exitosamente',
      answerCleared: 'Respuesta limpiada exitosamente',
      questionDeleted: 'Pregunta eliminada exitosamente',
      confirmDeleteTitle: 'Eliminar Pregunta',
      confirmDeleteMessage: '¿Está seguro de que desea eliminar esta pregunta: {{question}}?',
      validation: {
        actionItemIsNeeded: 'Se necesita un elemento de acción para completar la pregunta',
        commentIsNeeded: 'Se necesita un comentario para completar la pregunta',
        signatureIsNeeded: 'Se necesita una firma para completar la pregunta',
        responseIsNeeded: 'Se necesita una respuesta para completar la pregunta',
        actionItemsClosedOrCancelledNeeded:
          'Se necesitan elementos de acción {{P3Label}} cerrados o cancelados para completar la pregunta',
      },
    },
    forms: {
      labels: {
        title: 'Título',
        moc: 'MOC',
        wo: 'WO',
        description: 'Descripción',
        area: 'Área',
        facilityOperationTeam: 'Equipo de Operación de Instalación',
        facility: 'Instalación',
        project: 'Proyecto',
        template: 'Plantilla',
        type: 'Tipo',
      },
      placeholders: {
        title: 'texto de muestra',
        moc: 'texto de muestra',
        wo: 'texto de muestra',
        description: 'Ingresa descripción',
        area: 'selecciona uno',
        facilityOperationTeam: 'selecciona uno',
        facility: 'selecciona uno',
        project: 'selecciona uno',
        template: 'selecciona uno',
        type: 'selecciona uno',
      },
      validation: {
        titleRequired: 'El título es requerido',
        businessUnitRequired: 'La unidad de negocio es requerida',
        organizationRequired: 'La organización es requerida',
        areaRequired: 'El área es requerida',
        facilityOperationTeamRequired: 'El equipo de operación de instalación es requerido',
        facilityRequired: 'La instalación es requerida',
        templateRequired: 'La plantilla es requerida',
        typeRequired: 'El tipo es requerido',
        requiredFieldsMessage: 'Nota: Complete los campos marcados como obligatorios. Haga clic en Guardar.',
      },
      templateChangeConfirmTitle: 'Cambiar plantilla',
      templateChangeConfirmMessage:
        'Cambiar la plantilla actualizará las secciones del PSSR. ¿Está seguro de que desea cambiar la plantilla?',
    },
    mocImportedHint: 'Este PSSR fue importado. No puede cambiar su identificador',
    history: {
      reason: 'Motivo',
      by: 'Por',
      draftCreated: 'Borrador Creado El',
      initiated: 'Iniciado El',
      started: 'Comenzado El',
      completed: 'Completado El',
      pendingApproval: 'Aprobación Pendiente El',
      verbalApproval: 'Aprobación Verbal El',
      approved: 'Aprobado El',
      rejected: 'Rechazado El',
      restored: 'Restaurado El',
      deleted: 'Eliminado El',
      closed: 'Cerrado El',
    },
    actions: {
      save: 'guardar',
      saveGeneralInformation: 'guardar información general',
      showFullHistory: 'mostrar historial completo',
      showLessHistory: 'mostrar menos historial',
      attachFile: 'Adjuntar archivo (documentos, imágenes, dibujos psi, etc.)',
      attachFileButton: 'adjuntar archivo',
      printToPdf: 'imprimir a pdf',
      sendEmailReminder: 'enviar recordatorio por correo',
      importMocActionItems: 'importar elementos de acción moc',
      sendToMocStartup: 'enviar a registro moc para aprobación de inicio',
      returnToTeamLead: 'devolver al líder del equipo',
      start: 'iniciar pssr',
      reject: 'rechazar',
      delete: 'eliminar',
      restorePssr: 'restaurar pssr',
      reopen: 'reabrir',
    },
    successMessage: 'PSSR actualizado exitosamente',
    pdfDownloadSuccess: 'PDF descargado exitosamente',
    pssrDeletedSuccess: 'PSSR eliminado exitosamente',
    pssrReopenedSuccess: 'PSSR reabierto exitosamente',
    statusChangedSuccess: 'Estado de PSSR cambiado exitosamente',
    pssrRejectedSuccess: 'PSSR rechazado exitosamente',
    pssrRestoredSuccess: 'PSSR restaurado exitosamente',
    importMOCActionsSuccess: 'Elementos de acción MOC importados exitosamente',
    sendToMOCSuccess: 'Subido a MOC exitosamente',
    emailSentSuccess: 'Recordatorio por correo electrónico enviado exitosamente',
    importMOCActionsNone: 'No hay elementos de acción MOC para importar',
    lastSent: 'Último Envío',
    messages: {
      questionAdded: 'Pregunta agregada exitosamente',
    },
    dialogs: {
      addQuestion: {
        descriptionLabel: 'Descripción',
        descriptionPlaceholder: 'Ingrese la descripción de la pregunta',
        descriptionRequired: 'La descripción es obligatoria',
      },
    },
    rejectDialog: {
      title: 'Rechazar PSSR',
      reasonLabel: 'Razón del Rechazo',
      cancel: 'Cancelar',
      confirm: 'Rechazar',
    },
    emailReminderDialog: {
      title: 'Enviar Recordatorio por Correo',
      sendReminder: 'Enviar Recordatorio',
      sendMessage: 'Enviar Mensaje Personalizado',
      reminderInstructions:
        'Enviar recordatorio a los asignados para todos los AIs abiertos. Cuando el PSSR esté en estado de Aprobación Pendiente, los Aprobadores recibirán notificación.',
      messageInstructions: 'Enviar un mensaje de correo electrónico a todos los Participantes del PSSR',
      enterText: 'Ingrese su mensaje...',
      cancel: 'Cancelar',
      confirm: 'Enviar',
    },
    commentDialog: {
      title: 'Comentario',
      commentLabel: 'Comentario',
      commentPlaceholder: 'texto de muestra',
      createdBy: 'Creado por',
      updatedDate: 'Fecha de actualización',
      updatedBy: 'Actualizado por',
      documents: 'Documentos',
      delete: 'eliminar',
      cancel: 'cancelar',
      save: 'guardar',
      successMessage: 'Comentario actualizado exitosamente',
      confirmDeleteAttachment: '¿Está seguro de que desea eliminar este archivo adjunto?',
      confirmDeleteAttachmentHeader: 'Eliminar Archivo Adjunto',
      commentRequired: 'El comentario es obligatorio',
      addComment: 'Agregar Comentario',
      editComment: 'Editar Comentario',
      confirmDelete: '¿Está seguro de que desea eliminar este comentario?',
      confirmDeleteHeader: 'Eliminar Comentario',
      commentAdded: 'Comentario agregado exitosamente',
      commentUpdated: 'Comentario actualizado exitosamente',
      commentDeleted: 'Comentario eliminado exitosamente',
    },
    confirmDeleteHeader: 'Confirmar Eliminación',
    confirmDeleteMessage: 'Está a punto de eliminar este elemento. ¿Desea continuar?',
    confirmDeleteComment: '¿Está seguro de que desea eliminar este comentario?',
    commentDeletedSuccess: 'Comentario eliminado exitosamente',
    changeStatusHeader: 'Confirmar Cambio de Estado',
    confirmChangeStatus: '¿Desea cambiar el estado?',
    confirmRejectHeader: 'Confirmar Rechazo',
    confirmRejectMessage: '¿Está seguro de que desea rechazar este PSSR?',
    confirmReopenHeader: ' ',
    confirmReopenMessage: '¿Está seguro de que desea volver a abrir este PSSR?',
    comments: {
      title: 'Comentarios',
      addComment: 'agregar comentario',
      noComments: 'Sin comentarios',
      by: 'por',
      on: 'el',
    },
    validation: {
      onlyPSSRTeamLeadcanInitiatePSSR: 'Sólo Líder de Equipo PSSR y Aprobador Final pueden Iniciar PSSR',
      requireFinalApproverBeforeInitiation: 'Tildar si desea que PSSR exija inicio por Aprobador Final',
      pssrMustAnswerAllQuestionsToCompleteWalkdown: 'Responder todas las preguntas y firmas para completar PSSR',
      pssrMustHaveFinalApproverToCompleteWalkdown: 'PSSR debe tener Aprobador Final para completar Recorrido',
      onlyPSSRTeamLeadcanSubmitforPendingApproval: 'Sólo Líder de Equipo PSSR puede Enviar para Aprobación Pendiente',
      p3ActionItemsMustBeClosed: 'Se deben cerrar los AI P3',
      p4ActionItemsMustBeClosed: 'Se deben cerrar los AI P4',
      onlyFinalApprovercanApprovePSSR: 'Sólo Aprobador Final puede aprobar PSSR',
      onlyPSSRTeamLeadClosePSSR: 'Sólo Líder de Equipo PSSR puede cerrar PSSR',
    },
  },
  pdfDialog: {
    header: 'Adjuntar archivo PDF',
    selectTypePrompt: '¿Cómo desea adjuntar este PDF?',
    document: 'Documento',
    image: 'Imagen',
    selectPagesTitle: 'Seleccione las páginas para convertir en imágenes',
    allPages: 'Todas las páginas',
    selectPages: 'Seleccionar páginas',
    page: 'Página',
    select: 'Seleccionar',
    couldNotDetectPages: 'No se pudo detectar el número de páginas. Se incluirán todas las páginas.',
  },
  attachmentUpload: {
    title: 'Adjuntar Archivo',
    selectType: '¿Qué te gustaría adjuntar?',
    types: {
      link: 'Enlace',
      document: 'Documento',
      image: 'Imagen',
    },
    forms: {
      url: 'URL',
      urlPlaceholder: 'https://ejemplo.com',
    },
    clickToSelect: 'Haga clic para seleccionar un archivo',
    acceptedImageTypes: 'Formatos aceptados: JPG, PNG, GIF, etc.',
    acceptedDocumentTypes: 'Formatos aceptados: PDF, DOC, DOCX, XLS, XLSX',
    upload: 'Subir',
    successMessage: 'Archivo adjuntado exitosamente',
    sections: {
      images: 'Imágenes',
      documents: 'Documentos',
      links: 'Enlaces',
    },
    uploaded: 'Cargado',
    download: 'Descargar',
  },
  participants: {
    title: 'Participantes',
    addParticipant: 'agregar participante',
    addMember: 'Agregar miembro',
    pssrTeamLead: 'Líder de Equipo {{pssrTitle}}',
    pssrTeam: 'Equipo {{pssrTitle}}',
    projectManagers: 'Gerentes de Proyecto',
    projectTeamMembers: 'Miembros del Equipo del Proyecto',
    operationsRepresentative: 'Representante de Operaciones',
    finalApprover: 'Aprobador Final',
    actionItemAssignee: 'Asignado del Elemento de Acción',
    noParticipantsAdded: 'No se agregaron participantes',
    signedBy: 'firmado por',
    signedInBehalfOf: 'firmado en nombre de',
    signedOn: 'firmado el',
  },
  qaqcImport: {
    title: 'Importación QAQC',
    milestone: 'Hito QAQC',
    workOrders: 'Órdenes de trabajo QAQC',
    milestoneWorkOrders: 'Órdenes de trabajo del Hito QAQC (opcional)',
    milestoneWorkOrdersLabel: 'Órdenes de trabajo del Hito QAQC',
    milestoneWorkOrdersMessage: 'Seleccione 1 hito para ver las órdenes de trabajo dentro de ese hito',
    noItemsAvailable: 'No hay hitos/órdenes de trabajo disponibles de QAQC',
    noWorkOrdersForMilestone: 'No hay órdenes de trabajo disponibles para este hito',
    unableLoadItems: 'No se puede acceder al sistema QAQC para hitos/órdenes de trabajo, inténtelo de nuevo más tarde',
    loadEventsError: 'Error al obtener {{eventLabel}} de QAQC',
    multipleMilestonesWarning: 'Seleccionar 1 hito para visualizar órdenes de trabajo dentro de ese hito',
    generatePssrTitle: 'Generar Título PSSR',
    alreadyExists: 'Este evento QAQC ya existe como proyecto',
    selectEvent: 'Proyecto',
    sections: 'Secciones',
    assignSectionLeads: 'Asignar líderes de sección',
    selectLead: 'Seleccionar Líder',
    sectionName: 'Nombre de Sección',
    lead: 'Líder',
    template: 'Plantilla',
    type: 'Tipo',
    projectType: 'Tipo de Proyecto',
    successMessage: 'Importación QAQC completada. Proyecto y PSSRs creados.',
    errorMessage: 'Error al crear el proyecto QAQC. Intente nuevamente.',
    projectCreatedWithoutItems:
      'Proyecto creado. QAQC aún no tiene hitos ni órdenes de trabajo; use "Cargar nuevos ítems QAQC" cuando estén disponibles.',
    partialErrorMessage:
      'El proyecto se creó, pero no se pudieron crear sus PSSRs. Use "Cargar nuevos ítems QAQC" para intentarlo de nuevo.',
    somePssrsNotCreated:
      'Solo se crearon {{created}} de {{total}} PSSRs. Use "Cargar nuevos ítems QAQC" para crear el resto.',
  },
  participantDialog: {
    title: 'Seleccionar participante',
    addParticipant: 'Agregar Participante',
    selectUserType: 'Seleccionar Tipo de Usuario',
    selectedUserType: 'Tipo de Usuario Seleccionado',
    chevronDirectory: 'directorio chevron/usuarios compartidos',
    newNonChevron: 'nuevo no chevron',
    searchPlaceholder: 'Buscar por email...',
    emailPlaceholder: 'Ingresar email...',
    namePlaceholder: 'Ingresar nombre...',
    selectRole: 'Seleccionar rol',
    selectedRole: 'Rol Seleccionado',
    selectOne: 'seleccionar uno',
    add: 'agregar',
    stagedParticipants: 'a agregar:',
    batchLimitReached: 'límite de {{limit}} usuarios alcanzado, seleccione agregar',
    alreadyStagedError: 'este usuario ya está en la lista',
    successMessage: 'Participante agregado exitosamente',
    added: 'Participante agregado exitosamente',
    addError: 'Error al agregar participante',
    alreadyParticipantPssr: 'Este usuario ya es participante de este PSSR como {{role}}',
    alreadyMemberProject: 'Este usuario ya es miembro de este proyecto como {{role}}',
  },
  participantEditDialog: {
    title: 'Editar participante',
    user: 'Usuario',
    selectRole: 'Seleccionar rol',
    delete: 'eliminar',
    captureSignature: 'capturar firma',
    recaptureSignature: 'volver a capturar firma',
    removeSignature: 'eliminar firma',
    removeSignatureSuccess: 'Firma eliminada exitosamente',
    save: 'guardar',
    noSignature: 'No se capturó firma',
    successMessage: 'Participante actualizado exitosamente',
    deleteSuccessMessage: 'Participante eliminado exitosamente',
    deleteConfirmHeader: 'Eliminar participante',
    deleteConfirmMessage: '¿Está seguro de que desea eliminar este participante?',
  },
  buAdminsList: {
    title: 'Usuarios Administradores de BU',
    actions: {
      addNewUser: 'agregar usuario administrador',
      delete: 'eliminar',
    },
    table: {
      fullName: 'nombre completo',
      email: 'email',
    },
    noAdmins: 'No hay usuarios administradores disponibles',
  },
  externalUserForm: {
    labels: {
      firstName: 'Nombre',
      lastName: 'Apellido',
      email: 'Email',
      userNameEmail: 'Email o nombre de usuario',
    },
  },
  sharedUserForm: {
    labels: {
      sharedUserGroup: 'Grupo de Usuario Compartido',
      sharedEmail: 'Email Compartido',
    },
    actions: {
      addChildUser: 'agregar usuario',
      importSharedUsers: 'Importar usuarios compartidos',
    },
    whitePages: {
      title: 'Integración con White Pages',
      description:
        'Utilice este tipo de correo electrónico compartido si necesita sincronizar con White Pages. La lista de usuarios se actualizará automáticamente con el tiempo. Algunos usuarios pueden ser agregados o eliminados automáticamente de este correo electrónico compartido.',
    },
    customConfiguration: {
      title: 'Configuración Personalizada',
      description: 'Gestione manualmente la lista de usuarios.',
    },
  },
  pssrsList: {
    title: 'PSSR',
    location: 'Ubicación',
    details: 'Detalles',
    emptyMessage: 'No se encontraron PSSRs',
    searchByLocation: 'Ubicación',
    searchByDetails: 'Detalles',
    filters: {
      businessUnit: 'Unidad de Negocio',
      organization: 'Organización',
      area: '\u00c1rea',
      subArea: '\u00c1rea Sub',
      facilityOperationTeam: 'Equipo de Operación de Instalación',
      facility: 'Instalación',
      project: 'Proyecto',
      template: 'Plantilla',
      selectOne: 'seleccionar uno',
      status: 'Estado',
      type: 'Tipo',
      deletedStagnant: 'Eliminado/Estancado',
      showOnlyDeleted: 'mostrar solo PSSRs eliminados',
      showOnlyStagnant: 'mostrar solo PSSRs estancados',
      search: 'Buscar',
      placeholderSearch: 'buscar por moc, wo, id de pssr, título, etc...',
      userSearch: 'Búsqueda de Usuario',
      placeholderUserSearch: 'sample text',
      isStagnant: 'Está Estancado',
      isDeleted: 'Está Eliminado',
    },
    buttons: {
      clearFilter: 'limpiar filtro',
      newPssr: 'nuevo PSSR',
      viewItems: 'ver elementos',
      open: 'abrir',
    },
    actions: {
      clearFilter: 'Limpiar filtro',
      newPssr: 'nuevo pssr',
      importPssr: 'Importar PSSRs',
    },
    table: {
      id: 'ID',
      title: 'Título',
      type: 'Tipo',
      status: 'Estado',
      facility: 'Instalación',
      project: 'Proyecto',
    },
    statusOptions: {
      draft: 'Borrador',
      initiated: 'Iniciado',
      inProgress: 'En curso',
      completed: 'Completado',
      pendingApproval: 'Pendiente de Aprobación',
      approved: 'Aprobado',
      closed: 'Cerrado',
    },
    noPssrs: 'No hay PSSRs disponibles',
  },
  pssrListItem: {
    pssrId: 'ID DE PSSR',
    pssr: 'PSSR',
    moc: 'MOC',
    wo: 'WO',
    project: 'Proyecto',
    teamLeads: 'Líderes de Equipo',
    totalQuestions: 'Preguntas Totales',
    outstandingQuestions: 'Preguntas Pendientes',
    completedQuestions: 'Preguntas Completadas',
    area: '\u00c1rea',
    subArea: 'Sub \u00c1rea',
    facility: 'Instalación',
    qaqcStatus: 'Estado QAQC',
    qaqcMilestone: 'Hito QAQC',
    qaqcWorkOrder: 'Orden de trabajo QAQC',
    qaqcReady: '% listo',
    qaqcComplete: '% completo',
    qaqcAccepted: '% aceptado',
    qaqcSignatures: 'Firmas',
    qaqcDocuments: 'Documentos QAQC',
    qaqcNoData: 'Sin datos QAQC',
  },
  pssrStatuses: {
    Draft: 'Borrador',
    Initiated: 'Iniciado',
    InProgress: 'En curso',
    Completed: 'Completado',
    PendingApproval: 'Pendiente de Aprobación',
    Approved: 'Aprobado',
    Closed: 'Cerrado',
    Deleted: 'Eliminado',
    CreateDate: 'Borrador Creado',
    InitiatedOn: 'Iniciado',
    StartedOn: 'Iniciado',
    CompletedOn: 'Recorrida Completada',
    PendingApprovalOn: 'Pendiente de Aprobación Presentado',
    ApprovedOn: 'Aprobado el',
    ClosedOn: 'Cerrado el',
    DeletedOn: 'Eliminado el',
    RestoredOn: 'Restaurado el',
  },
  signatureCaptureDialog: {
    title: 'Capturar Firma',
    confirm: 'confirmar',
    saveSuccess: 'Firma capturada exitosamente',
  },
  projectsList: {
    title: 'Proyectos',
    table: {
      projectName: 'Nombre del proyecto',
      projectManager: 'Gerente del proyecto',
      status: 'Estado',
      completedTotalPssrs: 'Completados/total pssrs',
      actions: 'Acciones',
      dateCreated: 'Fecha de creación',
    },
    statusLabels: {
      active: 'activo',
      closed: 'cerrado',
    },
    sort: {
      placeholder: 'Ordenar por',
      nameAsc: 'Nombre (A-Z)',
      nameDesc: 'Nombre (Z-A)',
      statusAsc: 'Estado (Menor a Mayor)',
      statusDesc: 'Estado (Mayor a Menor)',
      dateAsc: 'Fecha de Creación (Más Antigua)',
      dateDesc: 'Fecha de Creación (Más Reciente)',
    },
    actions: {
      open: 'abrir',
      createProject: 'crear proyecto',
    },
    projectSearch: 'Búsqueda de proyectos',
    showDeletedProjects: 'Mostrar proyectos eliminados',
    searchPlaceholder: 'Buscar por nombre',
    datePlaceholder: 'mm/dd/yyyy - mm/dd/yyyy',
    statusPlaceholder: 'seleccione uno',
    noProjects: 'No hay proyectos disponibles',
  },
  projectEdit: {
    title: 'Editar Proyecto',
    projectName: 'Nombre del Proyecto',
    projectNamePlaceholder: 'Ingrese el nombre del proyecto',
    statusActive: 'activo',
    statusClosed: 'cerrado',
    statusDeleted: 'eliminado',
    teamMembers: 'Miembros del Equipo',
    addParticipant: 'agregar participante',
    pssrCcc: 'PSSR/CCC',
    newPssr: 'Nuevo {{pssrTitle}}',
    noPssrCcc: 'No hay PSSR/CCCs asociados con este proyecto.',
    delete: 'eliminar',
    markAsClosed: 'marcar como cerrado',
    reopen: 'reabrir',
    confirmDelete: '¿Está seguro de que desea eliminar este proyecto?',
    confirmDeleteHeader: 'Confirmar Eliminación',
    confirmDeletePssrs: '¿También desea eliminar todos los PSSRs asociados con este proyecto?',
    confirmDeletePssrsHeader: '¿Eliminar PSSRs?',
    deleteSuccess: 'Proyecto eliminado exitosamente',
    confirmMarkAsClosed: '¿Está seguro de que desea marcar este proyecto como cerrado?',
    confirmMarkAsClosedHeader: 'Confirmar Marcar como Cerrado',
    markedAsClosedSuccess: 'Proyecto marcado como cerrado exitosamente',
    confirmCloseProjectTitle: 'Confirmar Cerrar Proyecto',
    confirmCloseProjectDescription: '¿Está seguro de que desea marcar este proyecto como cerrado?',
    confirmReopenProjectTitle: 'Confirmar Reabrir Proyecto',
    confirmReopenProjectDescription: '¿Está seguro de que desea reabrir este proyecto?',
    cannotCloseProjectDueOpenPSSRs: 'No se puede cerrar el proyecto porque hay PSSRs abiertos.',
    projectUpdatedSuccessfully: 'Proyecto actualizado exitosamente',
    loadNewQaqcItems: 'Cargar nuevos ítems QAQC',
    qaqcItemsLoadedSuccessfully: 'Los nuevos ítems QAQC se cargaron exitosamente',
    qaqcItemsUpToDate: 'Los ítems QAQC ya están actualizados',
    qaqcInputWarning: 'Complete los campos QAQC requeridos antes de cargar nuevos ítems: {{fields}}.',
    initiateAll: 'Iniciar todos los PSSR',
    initiateAllTitle: 'Iniciar todos los PSSR',
    initiateAllDescription: '¿Desea iniciar todos los PSSR de este proyecto?',
    initiateAllSuccess: 'Todos los PSSR se iniciaron correctamente',
    initiateAllPartialError: 'No se pudieron iniciar algunos PSSR:',
    projectReopenedSuccessfully: 'Proyecto reabierto exitosamente',
    restorePssr: 'Restaurar',
    confirmRestoreProject: '¿Está seguro de que desea restaurar este proyecto?',
    confirmRestoreProjectHeader: 'Confirmar Restauración',
    restoreSuccess: 'Proyecto restaurado exitosamente',
    deleteDialog: {
      cascade: 'cascada',
      title: 'Confirmar Eliminación del Proyecto',
      confirmDeleteWithPssrs:
        'La siguiente acción podría borrar el Proyecto y los PSSRs involucrados. ¿Desea continuar?',
      confirmDeleteWithoutPssrs: '¿Desea continuar?',
      deleteProjectAndPssrs: 'Eliminar Proyecto y PSSRs',
      deleteProjectOnly: 'Eliminar Solo el Proyecto',
      deleteSuccess: 'Proyecto eliminado exitosamente',
      deleteError: 'Error al eliminar el proyecto',
    },
    cascadeDialog: {
      cascade: 'cascada',
      title: 'Roles en Cascada',
      description: 'Seleccione los participantes que desea aplicar en cascada a todos los PSSRs de este proyecto.',
      teamLeads: 'Líderes de Equipo',
      teamMembers: 'Miembros del Equipo',
      operationsRepresentative: 'Representante de Operaciones',
      finalApprover: 'Aprobador Final',
      apply: 'aplicar',
      success: 'Roles aplicados en cascada exitosamente',
    },
    errors: {
      noPermissionToEditParticipants: 'No tiene permiso para editar participantes en este proyecto',
    },
  },
  multiselect: {
    selectedItems: '{0} elementos seleccionados',
    placeholder: 'elegir',
  },
  support: {
    title: 'Retroalimentación',
    buSupportInfo: 'Información de Soporte de BU ePSSR',
    serviceNowInstructions: 'Instrucciones de Emisión de Tickets de ePSSR Service Now',
    instructions: {
      step1: 'Vaya al formulario de {{serviceNowLink}} en el Portal de Servicios de TI de Chevron',
      step1LinkText: 'Solicitud de Soporte de Aplicación',
      step2: 'En el campo de Aplicación seleccione <b>Mobile PSSR</b>.',
      step3:
        'Para reportar un problema o error, seleccione <b>Reportar un Problema</b>. Para enviar una solicitud de mejora o acceso de usuario, seleccione <b>Solicitud de Servicio</b>. Presione Siguiente.',
    },
    reportIssue: {
      title: 'Reportar un Problema',
      step1: 'Complete la Descripción del Problema, Impacto y Urgencia.',
      step2: 'Presione Siguiente y luego Enviar.',
      step3: 'El Equipo de Soporte de ePSSR confirmará la recepción del ticket en 24 horas durante el horario laboral.',
    },
    enhancement: {
      title: 'Solicitud de Mejora',
      step1: 'Por favor seleccione <b>Mejoras</b> en Tipo de Solicitudes.',
      step2: 'Seleccione Prioridad (<b>Baja, Moderada, Alta</b>)',
      step3: 'Complete la Descripción de la Solicitud',
      step4: 'Seleccione Siguiente y Enviar.',
      step5:
        'El Equipo de Soporte de ePSSR revisará las solicitudes de mejora como parte del Proceso de Planificación PI de Surface Digital',
    },
    userAccess: {
      title: 'Solicitud de Acceso de Usuario',
      step1: 'Por favor seleccione <b>Solicitar Acceso</b> en Tipo de Solicitudes.',
      step2: 'Seleccione Tipo de Solicitud de Acceso (<b>Agregar o Eliminar</b>)',
      step3: 'Seleccione un usuario',
      step4: 'Seleccione Prioridad (<b>Baja, Moderada, Alta</b>)',
      step5: 'Especifique el Rol y Acceso que necesita el Usuario.',
      step6: 'Seleccione Siguiente y Enviar.',
      step7: 'El Equipo de Soporte de ePSSR confirmará la recepción del ticket en 24 horas durante el horario laboral.',
    },
  },
  datepicker: {
    dayNames: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
    dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
    dayNamesMin: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa'],
    monthNames: [
      'Enero',
      'Febrero',
      'Marzo',
      'Abril',
      'Mayo',
      'Junio',
      'Julio',
      'Agosto',
      'Septiembre',
      'Octubre',
      'Noviembre',
      'Diciembre',
    ],
    monthNamesShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
    today: 'Hoy',
    clear: 'Limpiar',
    dateFormat: 'mm/dd/yy',
    weekHeader: 'Sm',
  },
  errors: {
    unauthorized: {
      title: 'Acceso no autorizado',
      message: 'No tiene permiso para acceder a esta página.',
    },
    serverError: {
      title: 'Error del servidor',
      message: 'Ocurrió un error inesperado. Inténtelo de nuevo más tarde.',
    },
    pageNotFound: {
      title: 'Página no encontrada',
      message: 'La página que está buscando no existe.',
    },
    actions: {
      returnHome: 'Volver al inicio',
    },
  },
  attachments: {
    sections: {
      images: 'Imágenes',
      documents: 'Documentos',
      links: 'Enlaces',
    },
    actions: {
      download: 'Descargar',
      delete: 'Eliminar',
    },
    labels: {
      uploaded: 'Subido',
    },
  },
  imagePreview: {
    errorMessage: 'No se pudo cargar la imagen',
    errorDetails: 'Revise la consola del navegador para más detalles',
  },
  functionalReview: {
    audit: {
      createdBy: 'Creado por',
      updatedDate: 'Fecha de actualización',
      updatedBy: 'Actualizado por',
    },
  },
  checklistItem: {
    toolbar: {
      bold: 'Negrita',
      italic: 'Cursiva',
      underline: 'Subrayado',
      orderedList: 'Lista ordenada',
      unorderedList: 'Lista desordenada',
      codeBlock: 'Bloque de código',
      blockQuote: 'Cita en bloque',
    },
    alignment: {
      center: 'centrado',
      right: 'derecha',
      justify: 'justificado',
    },
  },
  pssrSections: {
    actions: {
      removeUser: 'Quitar usuario',
    },
  },
  pssrParticipantsSections: {
    actions: {
      remove: 'Quitar',
    },
  },
  progressBar: {
    label: 'Progreso:',
  },
  categories: {
    dialogs: {
      addCategory: 'Añadir categoría',
      editCategory: 'Editar categoría',
      createSubCategory: 'Crear nueva subcategoría',
      editSubCategory: 'Editar subcategoría',
    },
    placeholders: {
      subcategoryName: 'Nombre de subcategoría',
    },
  },
  categoriesList: {
    title: 'Categorías',
    hideInactiveItems: 'Ocultar categorías inactivas',
    subCategoryName: 'Nombre de subcategoría',
    inactive: '(inactivo)',
    noSubcategories: 'Sin subcategorías',
    selectHeader: 'Seleccionar',
    actions: {
      createSubCategory: 'Crear nueva subcategoría',
      restore: 'Restaurar',
      add: 'Agregar',
      addSubCategories: 'Agregar subcategorías',
      remove: 'Quitar',
    },
    deleteDisabledTooltip: 'Esta categoría no puede eliminarse porque contiene subcategorías activas',
    dialogs: {
      addSubCategoriesHeader: 'Agregar subcategorías',
      deleteCategoryHeader: 'Atención',
      deleteCategoryMessage: '¿Está seguro de que desea eliminar la Categoría: [{{name}}]?',
      deleteSubCategoryHeader: 'Atención',
      deleteSubCategoryMessage: '¿Quitar [{{name}}] de la categoría [{{category}}]? La subcategoría en sí no se eliminará.',
    },
    validation: {
      subCategoryExists: 'Ya existe una subcategoría con ese nombre',
      categoryExists: 'Ya existe una categoría con ese nombre',
    },
  },
};
export default es;
